export function performanceQueueFactory() {
    return window.queuedMarks || [];
}
